import React from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";
import { URLS } from "@/shared/utils/url/url";

import { default as SharedLogotype } from "@/shared/components/Logotype/Logotype";

const Logotype = ({ className, writingsTextClassName, text, isShowRegistered, onClick }) => {
  const router = useRouter();

  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick(e);
    }
    router.push(URLS.home);
  };

  return (
    <SharedLogotype
      className={className}
      writingsTextClassName={writingsTextClassName}
      text={text}
      isShowLogoWritingsLabel={true}
      isShowRegistered={isShowRegistered}
      isShowLogoLinks={false}
      scrollToTop={!router.asPath || router.route === "/"}
      onClick={handleClick}
    />
  );
};

Logotype.defaultProps = {
  isShowRegistered: true,
  text: "writings",
  href: "/",
};

Logotype.propTypes = {
  className: PropTypes.string,
  isShowRegistered: PropTypes.bool,
  href: PropTypes.string,
  text: PropTypes.string,
  writingsTextClassName: PropTypes.string,
  onClick: PropTypes.func,
};

export default Logotype;
